// tslint:disable: variable-name
// tslint:disable: max-classes-per-file

import { CommodityViewModel } from '@models/commodities.class';

export interface IInternalBrokerMessage {
  name: string;
  date: string;
  percentageChange: number;
  price: number;
  volume: number;
  unitChange: number;
  lastValue: number;
  type: number;
  closeValue: number;
}

export interface IBrokerMessage {
  Timestamp: string;
  ChangePercent: number;
  Value: number;
  Volume: number;
  ChangeUnit: number;
  Type: number;
  CloseValue: number;
}

export interface IBrokerMessageIndex {
  GBL_INDEX: string;
}

export interface IBrokerMessageCommodity {
  METALS: string;
}
export interface IBrokerMessageCurrency {
  CURRENCY: string;
}

export enum LegacyCommodityGroups {
  currencies = 18,
  indexes = 22,
  commodities = 23,
  rates = 24,
}

export enum CommodityGroups {
  currencies = '2eb6d3be-4f51-4551-93fc-006930518e4d',
  indexes = '2a16bb58-8b8c-46cc-9c6e-776922fad841',
  commodities = 'f3851585-1456-4fcd-a6cb-23ef31dd351b',
  rates = 'f2bbc49e-37eb-4b92-a4c5-0a4e241817e0',
}

/**
 * This adapter is meant to transform data from server into a
 * structure solace-like. This base clase will help specific classes
 * to acchieve this transformation.
 *
 * @export
 */
export abstract class BaseCommodityAdapter implements IBrokerMessage {
  public Timestamp: string;
  public ChangePercent: number;
  public Value: number;
  public Volume: number;
  public ChangeUnit: number;
  public Type: number;
  public CloseValue: number;

  abstract type: CommodityGroups;
  abstract marketName: string;
  abstract get subtopic(): string;

  constructor(private commodity: CommodityViewModel) {
    this.Timestamp = new Date().toISOString().replace('T', ' ');
    this.ChangePercent = this.commodity.variationPercentage;
    this.Value = this.commodity.value;
    this.Volume = this.commodity.volume;
    this.ChangeUnit = this.commodity.variation;
    this.Type = this.commodity.typeId;
    this.CloseValue = this.commodity.previousClose;
  }

  public parse() {
    const index: IInternalBrokerMessage = {
      name: this.subtopic,
      date: this.Timestamp,
      percentageChange: this.ChangePercent,
      price: this.Value,
      volume: this.Volume,
      unitChange: this.ChangeUnit,
      lastValue: this.Value,
      type: this.Type,
      closeValue: this.CloseValue,
    };

    return index;
  }
}

export class IndexCommodity
  extends BaseCommodityAdapter
  implements IBrokerMessage, IBrokerMessageIndex
{
  type = CommodityGroups.indexes;
  marketName = 'indexes';
  GBL_INDEX: string;
  constructor(index: CommodityViewModel) {
    super(index);
    this.GBL_INDEX = index.name;
  }

  public get subtopic() {
    return this.GBL_INDEX.toUpperCase();
  }
}

export class CommodityCommodity
  extends BaseCommodityAdapter
  implements IBrokerMessage, IBrokerMessageCommodity
{
  type = CommodityGroups.commodities;
  marketName = 'commodities';
  METALS: string;
  constructor(commodity: CommodityViewModel) {
    super(commodity);
    this.METALS = commodity.name;
  }

  public get subtopic() {
    return this.METALS.toUpperCase();
  }
}

export class CurrencyCommodity
  extends BaseCommodityAdapter
  implements IBrokerMessage, IBrokerMessageCurrency
{
  type = CommodityGroups.currencies;
  marketName = 'currencies';
  CURRENCY: string;
  constructor(currency: CommodityViewModel) {
    super(currency);
    this.CURRENCY = currency.name;
  }

  public get subtopic() {
    return this.CURRENCY.toUpperCase();
  }
}
